import { IdentityUserAri } from '@atlassian/ari';

const OUTGOING_RELATIONSHIPS = ['user_assigned_issue'];
const INCOMING_RELATIONSHIPS = ['atlas_goal_has_owner', 'atlas_project_has_owner'];
const PR_RELATIONSHIPS = ['user_reviews_pr', 'user_authored_pr'];

const generateOutgoingCypherQuery = (accountId: string, relationships: string[]): string => {
	const userAri = IdentityUserAri.create({ userId: accountId }).toString();

	return `MATCH (user:IdentityUser {ari: '${userAri}'})-[rel:${relationships.join('|')}]->(entity) RETURN entity, rel.createdAt ORDER BY rel.createdAt DESC`;
};

const generateIncomingCypherQuery = (accountId: string, relationships: string[]): string => {
	const userAri = IdentityUserAri.create({ userId: accountId }).toString();

	return `MATCH (user:IdentityUser {ari: '${userAri}'})<-[rel:${relationships.join('|')}]-(entity) RETURN entity, rel.createdAt ORDER BY rel.createdAt DESC`;
};

export const createOutgoingCypherQuery = (accountId: string): string =>
	generateOutgoingCypherQuery(accountId, OUTGOING_RELATIONSHIPS);

export const createIncomingCypherQuery = (accountId: string): string =>
	generateIncomingCypherQuery(accountId, INCOMING_RELATIONSHIPS);

export const createPullRequestCypherQuery = (accountId: string): string =>
	generateOutgoingCypherQuery(accountId, PR_RELATIONSHIPS);
